var __makeTemplateObject = this && this.__makeTemplateObject || function (cooked, raw) {
  if (Object.defineProperty) {
    Object.defineProperty(cooked, "raw", {
      value: raw
    });
  } else {
    cooked.raw = raw;
  }
  return cooked;
};
var __assign = this && this.__assign || function () {
  __assign = Object.assign || function (t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
      s = arguments[i];
      for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
    }
    return t;
  };
  return __assign.apply(this, arguments);
};
import React from 'react';
import styled, { css } from 'styled-components';
import { classNames, firstStringProperty } from '@shapeable/utils';
var cls = classNames('entity-cell');
import { breakpoints, theme } from '@shapeable/theme';
import { EntityThumbnailImage } from './entity-image';
import { useLink } from '../hooks/use-link';
export var EntityCellDefaultProps = {
  aspectRatio: {
    base: 21 / 9,
    tablet: 16 / 9
  },
  stack: false,
  autoLink: true,
  showPretitle: false,
  showSubtitle: false
};
// -------- Styles -------->
var BodyStyles = breakpoints({
  base: css(templateObject_2 || (templateObject_2 = __makeTemplateObject(["\n    display: flex;\n    flex-direction: column;\n    color: ", ";\n\n    p {\n      line-height: 1.5em;\n      font-size: 0.9em;\n      margin-top: ", ";\n    }\n\n    h1 {\n      margin-top: 0;\n      margin-bottom: 0;\n      font-size: 1.3em;\n      font-weight: 400;\n      margin-bottom: 0.5em;\n      color: ", ";\n    }\n\n    ", "\n  "], ["\n    display: flex;\n    flex-direction: column;\n    color: ", ";\n\n    p {\n      line-height: 1.5em;\n      font-size: 0.9em;\n      margin-top: ", ";\n    }\n\n    h1 {\n      margin-top: 0;\n      margin-bottom: 0;\n      font-size: 1.3em;\n      font-weight: 400;\n      margin-bottom: 0.5em;\n      color: ", ";\n    }\n\n    ", "\n  "])), theme.COLOR('strong'), theme.UNIT(2), theme.COLOR('strong'), function (_a) {
    var isLink = _a.isLink;
    return isLink && css(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n      &:hover img {\n        filter: brightness(1.1);\n      }\n    "], ["\n      &:hover img {\n        filter: brightness(1.1);\n      }\n    "])));
  }),
  tablet: css(templateObject_4 || (templateObject_4 = __makeTemplateObject(["\n    flex-direction: row;\n    p {\n      margin-top: ", ";\n    }\n\n    ", "\n  "], ["\n    flex-direction: row;\n    p {\n      margin-top: ", ";\n    }\n\n    ", "\n  "])), theme.UNIT(2), function (_a) {
    var stack = _a.stack;
    return stack && css(templateObject_3 || (templateObject_3 = __makeTemplateObject(["\n      flex-direction: column;\n    "], ["\n      flex-direction: column;\n    "])));
  })
});
var TitleStyles = breakpoints({
  base: css(templateObject_5 || (templateObject_5 = __makeTemplateObject(["\n    font-family: ", ";\n  "], ["\n    font-family: ", ";\n  "])), theme.FONT('serif'))
});
var SummaryStyles = breakpoints({
  base: css(templateObject_6 || (templateObject_6 = __makeTemplateObject(["\n    font-size: 1em;    \n\n    p {\n      margin: 0 0 1em;\n    }\n  "], ["\n    font-size: 1em;    \n\n    p {\n      margin: 0 0 1em;\n    }\n  "])))
});
var InfoStyles = breakpoints({
  base: css(templateObject_7 || (templateObject_7 = __makeTemplateObject(["\n    box-sizing: border-box;\n    display: flex;\n    flex-direction: column;\n    font-weight: 300;\n    width: 100%;\n    padding: ", " ", " ", " ", ";\n  "], ["\n    box-sizing: border-box;\n    display: flex;\n    flex-direction: column;\n    font-weight: 300;\n    width: 100%;\n    padding: ", " ", " ", " ", ";\n  "])), theme.UNIT(4), theme.UNIT(3), theme.UNIT(0), theme.UNIT(3)),
  tablet: css(templateObject_9 || (templateObject_9 = __makeTemplateObject(["\n    width: 50%;\n    padding: 0 ", ";\n\n    ", "\n  "], ["\n    width: 50%;\n    padding: 0 ", ";\n\n    ", "\n  "])), theme.UNIT(5), function (_a) {
    var stack = _a.stack;
    return stack && css(templateObject_8 || (templateObject_8 = __makeTemplateObject(["\n      padding: ", ";\n      width: 100%;\n    "], ["\n      padding: ", ";\n      width: 100%;\n    "])), theme.UNIT(4));
  })
});
var ImageContainerStyles = breakpoints({
  base: css(templateObject_10 || (templateObject_10 = __makeTemplateObject(["\n    flex-shrink: 0;\n    width: 100%;\n  "], ["\n    flex-shrink: 0;\n    width: 100%;\n  "]))),
  tablet: css(templateObject_12 || (templateObject_12 = __makeTemplateObject(["\n    width: 50%;\n    ", "\n  "], ["\n    width: 50%;\n    ", "\n  "])), function (_a) {
    var stack = _a.stack;
    return stack && css(templateObject_11 || (templateObject_11 = __makeTemplateObject(["\n      width: 100%;\n    "], ["\n      width: 100%;\n    "])));
  })
});
var ImageStyles = breakpoints({
  base: css(templateObject_13 || (templateObject_13 = __makeTemplateObject(["\n    \n  "], ["\n    \n  "])))
});
var PretitleStyles = breakpoints({
  base: css(templateObject_14 || (templateObject_14 = __makeTemplateObject(["\n    margin: 0.5em 0;\n    font-size: 1em;\n    font-weight: 400;\n  "], ["\n    margin: 0.5em 0;\n    font-size: 1em;\n    font-weight: 400;\n  "])))
});
var SubtitleStyles = breakpoints({
  base: css(templateObject_15 || (templateObject_15 = __makeTemplateObject(["\n    margin: 0 0 0.5em;\n    font-weight: 400;\n    font-size: 1em;\n    font-weight: 400;\n  "], ["\n    margin: 0 0 0.5em;\n    font-weight: 400;\n    font-size: 1em;\n    font-weight: 400;\n  "])))
});
// -------- Components -------->
var My = {
  Container: styled.div(templateObject_16 || (templateObject_16 = __makeTemplateObject([""], [""]))),
  Body: styled.div.attrs(cls.attr('body'))(templateObject_17 || (templateObject_17 = __makeTemplateObject(["", ""], ["", ""])), BodyStyles),
  ImageContainer: styled.div.attrs(cls.attr('image-container'))(templateObject_18 || (templateObject_18 = __makeTemplateObject(["", ""], ["", ""])), ImageContainerStyles),
  Image: styled(EntityThumbnailImage)(templateObject_19 || (templateObject_19 = __makeTemplateObject(["", ""], ["", ""])), ImageStyles),
  Info: styled.div.attrs(cls.attr('info'))(templateObject_20 || (templateObject_20 = __makeTemplateObject(["", ""], ["", ""])), InfoStyles),
  Pretitle: styled.h2.attrs(cls.attr('pretitle'))(templateObject_21 || (templateObject_21 = __makeTemplateObject(["", ""], ["", ""])), PretitleStyles),
  Title: styled.h1.attrs(cls.attr('title'))(templateObject_22 || (templateObject_22 = __makeTemplateObject(["", ""], ["", ""])), TitleStyles),
  Subtitle: styled.h3.attrs(cls.attr('subtitle'))(templateObject_23 || (templateObject_23 = __makeTemplateObject(["", ""], ["", ""])), SubtitleStyles),
  Summary: styled.p.attrs(cls.attr('summary'))(templateObject_24 || (templateObject_24 = __makeTemplateObject(["", ""], ["", ""])), SummaryStyles)
};
export var EntityCell = function (props) {
  var className = props.className,
    entity = props.entity,
    aspectRatio = props.aspectRatio,
    stack = props.stack,
    onClick = props.onClick,
    image = props.image,
    showPretitle = props.showPretitle,
    showSubtitle = props.showSubtitle;
  // console.log("ENTITY CELL", entity);
  var style = props.style || {
    textDecoration: 'none'
  };
  var Link = useLink().Link;
  var isLink = !onClick && !!entity.path;
  var title = firstStringProperty(entity, ['title', 'name', 'openGraph.title']);
  var pretitle = entity.pretitle;
  var subtitle = entity.subtitle;
  var summary = firstStringProperty(entity, ['openGraph.description.plain', 'openGraph.description.text', 'summary.text', 'intro.text', 'description.plain', 'description.text']);
  var hasSubtitle = showSubtitle && subtitle;
  var hasPretitle = showPretitle && pretitle;
  var Container = isLink ? Link : My.Container;
  var containerProps = entity.path ? {
    href: entity.path
  } : {};
  return (
    // @ts-ignore
    React.createElement(Container, __assign({
      onClick: onClick,
      style: style
    }, containerProps), React.createElement(My.Body, {
      isLink: isLink,
      stack: stack,
      className: cls.name(className)
    }, React.createElement(My.ImageContainer, {
      stack: stack
    }, image || React.createElement(My.Image, {
      aspectRatio: aspectRatio,
      entity: entity
    })), React.createElement(My.Info, {
      stack: stack
    }, hasPretitle && React.createElement(My.Pretitle, {
      className: cls.sub('pretitle')
    }, pretitle), React.createElement(My.Title, {
      className: cls.sub('title')
    }, title), hasSubtitle && React.createElement(My.Subtitle, {
      className: cls.sub('subtitle')
    }, subtitle), React.createElement(My.Summary, null, summary))))
  );
};
EntityCell.cls = cls;
EntityCell.defaultProps = EntityCellDefaultProps;
var templateObject_1, templateObject_2, templateObject_3, templateObject_4, templateObject_5, templateObject_6, templateObject_7, templateObject_8, templateObject_9, templateObject_10, templateObject_11, templateObject_12, templateObject_13, templateObject_14, templateObject_15, templateObject_16, templateObject_17, templateObject_18, templateObject_19, templateObject_20, templateObject_21, templateObject_22, templateObject_23, templateObject_24;